import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosServices from '../../utils/axios';

const initialState = {
    industry: [],
    vehicles: [],
    loading: false,
    error: null,
    actionLoading: false // ekleme/güncelleme işlemleri için
};

export const fetchIndustry = createAsyncThunk(
    'industry/fetchIndustry',
    async (_, { rejectWithValue }) => {
        try { 
            const response = await axiosServices.get(`${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/App/get-auto-industry`);

            if (response.data?.statu === 200) {
                return response.data.data || [];
            }
            
            return rejectWithValue(response.data?.exceptions?.[0] || 'Sanayi verisi alınamadı');
        } catch (error) {
            console.error("API hatası:", error);
            return rejectWithValue(error.message || 'Sanayiler yüklenirken bir hata oluştu');
        }
    }
);

export const addIndustry = createAsyncThunk(
    'industry/addIndustry',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/App/new-auto-industry`,
                data
            );
            
            if (response.data?.statu === 200) {
                await dispatch(fetchIndustry());
                return response.data.data;
            }

            // API'den gelen hata mesajlarını kontrol et
            if (response.data?.exceptions?.length > 0) {
                return rejectWithValue(response.data.exceptions[0]);
            }
            
            if (response.data?.message) {
                return rejectWithValue(response.data.message);
            }

            return rejectWithValue('Sanayi alanı eklenirken bir hata oluştu');
        } catch (error) {
            if (error.response?.data?.exceptions?.length > 0) {
                return rejectWithValue(error.response.data.exceptions[0]);
            }
            return rejectWithValue(error.message || 'Sunucu hatası oluştu');
        }
    }
);

export const updateIndustry = createAsyncThunk(
    'industry/updateIndustry',
    async (data, { rejectWithValue, dispatch }) => {
        console.log(data);
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/App/update-auto-industry`,
                data
            );
            
            if (response.data?.statu === 200) {
                await dispatch(fetchIndustry());
                return response.data.data;
            }

            // API'den gelen hata mesajlarını kontrol et
            if (response.data?.exceptions?.length > 0) {
                return rejectWithValue(response.data.exceptions[0]);
            }
            
            if (response.data?.message) {
                return rejectWithValue(response.data.message);
            }

            return rejectWithValue('Sanayi alanı güncellenirken bir hata oluştu');
        } catch (error) {
            if (error.response?.data?.exceptions?.length > 0) {
                return rejectWithValue(error.response.data.exceptions[0]);
            }
            return rejectWithValue(error.message || 'Sunucu hatası oluştu');
        }
    }
);

export const deleteIndustry = createAsyncThunk(
    'industry/deleteIndustry',
    async (idAutoIndustry, { rejectWithValue, dispatch }) => {
        try {
            const response = await axiosServices.post(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/App/delete-auto-industry?idAutoIndustry=${idAutoIndustry}`,
            );
            
            if (response.data?.statu === 200) {
                await dispatch(fetchIndustry());
                return response.data.data;
            }

            if (response.data?.exceptions?.length > 0) {
                return rejectWithValue(response.data.exceptions[0]);
            }
            
            return rejectWithValue('Sanayi alanı silinirken bir hata oluştu');
        } catch (error) {
            if (error.response?.data?.exceptions?.length > 0) {
                return rejectWithValue(error.response.data.exceptions[0]);
            }
            return rejectWithValue(error.message || 'Sunucu hatası oluştu');
        }
    }
);

export const fetchVehicleBrands = createAsyncThunk(
    'industry/fetchVehicleBrands',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosServices.get(
                `${import.meta.env.VITE_REACT_APP_APIURL}/callcenter-service/api/Supplier/get-vehicle`
            );

            if (response.data?.statu === 200) { 
                return response.data.data.filter(vehicle => vehicle.flValid);
            }

            return rejectWithValue(response.data?.exceptions?.[0] || 'Araç markaları alınamadı');
        } catch (error) {
            console.error("API hatası:", error);
            return rejectWithValue(error.message || 'Araç markaları yüklenirken bir hata oluştu');
        }
    }
);

const industrySlice = createSlice({
    name: 'industry',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchIndustry.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchIndustry.fulfilled, (state, action) => {
                state.loading = false;
                state.industry = action.payload;
                state.error = null;
            })
            .addCase(fetchIndustry.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.industry = [];
            })
            .addCase(addIndustry.pending, (state) => {
                state.actionLoading = true;
                state.error = null;
            })
            .addCase(addIndustry.fulfilled, (state) => {
                state.actionLoading = false;
                state.error = null;
            })
            .addCase(addIndustry.rejected, (state, action) => {
                state.actionLoading = false;
                state.error = action.payload;
            })
            .addCase(updateIndustry.pending, (state) => {
                state.actionLoading = true;
                state.error = null;
            })
            .addCase(updateIndustry.fulfilled, (state) => {
                state.actionLoading = false;
                state.error = null;
            })
            .addCase(updateIndustry.rejected, (state, action) => {
                state.actionLoading = false;
                state.error = action.payload;
            })
            .addCase(deleteIndustry.pending, (state) => {
                state.actionLoading = true;
                state.error = null;
            })
            .addCase(deleteIndustry.fulfilled, (state) => {
                state.actionLoading = false;
                state.error = null;
            })
            .addCase(deleteIndustry.rejected, (state, action) => {
                state.actionLoading = false;
                state.error = action.payload;
            })
            .addCase(fetchVehicleBrands.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchVehicleBrands.fulfilled, (state, action) => {
                state.loading = false;
                state.vehicles = action.payload;
                state.error = null;
            })
            .addCase(fetchVehicleBrands.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.vehicles = [];
            });
    }
});

export default industrySlice.reducer;
